import { ApplicationActivity } from "../types";
import { getFullName } from "shared/utils/get-full-name";

export const IdentityVerificationOverride = ({
  activityItem
}: {
  activityItem: ApplicationActivity;
}) => {
  return (
    <p className="text-base font-bold text-content-1000">
      Identity verification was manually overridden for{" "}
      <span className="font-normal">
        {getFullName({
          firstName: activityItem.details.contact?.first_name || "",
          lastName: activityItem.details.contact?.last_name || "",
          middleName: activityItem.details.contact?.middle_name,
          short: true
        })}
      </span>
    </p>
  );
};
